<template lang="pug">
div(class='h-12')
  BaseFormSelect(v-model='selectedCountry' :options='countries' :classes='{ input: "h-full" }')
</template>

<script>
export default defineNuxtComponent({
  name: 'DealerLocatorCountrySelector',
  setup() {
    const { $algolia } = useNuxtApp()

    // Set SearchProvider here so we don't have to do $algolia.searchContexts everywhere
    const dealerLocatorInternational = $algolia.searchContexts.dealerLocatorInternational

    return {
      dealerLocatorInternational,
    }
  },
  data() {
    return {
      countries: [],
      selectedCountry: '',
    }
  },
  watch: {
    selectedCountry(newVal) {
      // Clear existing country
      this.dealerLocatorInternational.clearRefinements('country')
      // if we have a country value then set it
      if (newVal) this.dealerLocatorInternational.addRefinements('country', newVal)
      // trigger new search
      this.dealerLocatorInternational.search()
    },
  },
  mounted() {
    this.getCountries()
  },
  methods: {
    async getCountries() {
      try {
        // this is using a private method we use internally that gets the results but doesn't set the state.
        const { refinements } = await this.dealerLocatorInternational._search()

        // Get country facet from search
        const countryFacetValues = refinements.country

        // If we don't have any then return
        if (!countryFacetValues) return

        // Set countries equal to the values
        this.countries = countryFacetValues.map(({ value, display }) => ({
          label: display,
          value,
        }))
        // Add disabled selection to start of countries list for FormKit data
        this.countries.unshift({ label: 'Please Select A Country', value: '', attrs: { disabled: true } })
      } catch (error) {
        console.log('Unable to get country facts')
      }
    },
  },
})
</script>
